<template>
  <ten-menu-item
    :is-menu="true"
    v-bind="$attrs"
  >
    <template v-slot:default>
      <!-- 子菜单标题 -->
      <slot name="title" />
    </template>
    <template
      v-slot:icon
      v-if="$scopedSlots.icon"
    >
      <!-- 子菜单 icon -->
      <slot name="icon" />
    </template>
    <template v-slot:children>
      <slot name="child" />
      <slot name="children" />
    </template>
  </ten-menu-item>
</template>

<script>
import TenMenuItem from './menu-item';

const name = 'ten-submenu';
export default {
  name,
  components: {
    TenMenuItem,
  },
  inject: ['menu'],
};

</script>
